//主页面
// const index = r => require.ensure([], () => r(require('@/components/home.vue')), 'index');
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

// 产品主数据详情
const productionDataList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/productionData/list.vue');

//新增原料主数据
const productionDataAdd = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/productionData/add.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'productionDataList',
      name: 'productionDataList',
      component: productionDataList,
      meta: {
        keepAlive: true,
        title: '产品主数据',
      },
    },
    {
      path: 'productionDataAdd',
      name: 'productionDataAdd',
      component: productionDataAdd,
      meta: {
        keepAlive: true,
        title: '产品主数据新增',
      },
    },
  ],
};
export default productionRouter;
